import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { BASE_URL } from "../env";
import { developAxios } from "../axios.config";

const ShowAllCourseId = () => {
	let { id } = useParams();
	const [course, setCourse] = useState([]);
	const [totalClasses, settotalClasses] = useState("");
	const [totalAssignments, settotalAssignments] = useState("");
	const [totalTests, settotalTests] = useState("");
	const [totalStudents, settotalStudents] = useState("");
	const [courseDeadline, setCourseDeadline] = useState("2000-01-01");

	useEffect(() => {
		fetch(BASE_URL + "/getCoursewithoutauth/" + id)
			.then((res) => res.json())
			.then((data) => {
				setCourse(data);
				settotalClasses(data.data[0].totalClasses);
				settotalAssignments(data.data[0].totalAssignments);
				settotalTests(data.data[0].totalTests);
				settotalStudents(data.data[0].totalStudents);
			});
	}, [id]);

	return (
		<>
			<div className="title">
				<h1>{course[0]?.name}</h1>
				<br />
				Enter the total Number of Classes
				<input
					value={totalClasses}
					onChange={(e) => settotalClasses(e.target.value)}
				/>
				<br />
				Enter the total Number of Assignments
				<input
					value={totalAssignments}
					onChange={(e) => settotalAssignments(e.target.value)}
				/>
				<br />
				Enter the total Number of Tests
				<input
					value={totalTests}
					onChange={(e) => settotalTests(e.target.value)}
				/>
				<br />
				Enter the total Number of Students
				<input
					type="number"
					value={totalStudents}
					onChange={(e) => settotalStudents(e.target.value)}
				/>
				<br />
				<label for="course_deadline">Enter course deadline:</label>
				<input
					type="date"
					name="course_deadline"
					value={courseDeadline}
					onChange={(e) => setCourseDeadline(e.target.value)}
					id="course_deadline"
				/>
				<br />
				<button
					onClick={() => {
						developAxios("")
							.post(`/updatedataofcourses/${id}`, {
								totalClasses,
								totalAssignments,
								totalTests,
								totalStudents,
								courseDeadline,
							})
							.then(({ data }) => console.log(data))
							.catch((err) => console.log(err));
					}}
				>
					Update
				</button>
			</div>
		</>
	);
};

export default ShowAllCourseId;
